<script setup>
import {ref, reactive, onMounted} from 'vue'
import {addOrUpdateOnlineStore, editOrUpdateOnlineStore, onlineStoreDetail} from "@/api/onlineStore/onlineStore.js";
import moment from "moment";
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import YTAddress from "@/components/YTAddress/index.vue";

// 表单加载状态
const loading = ref(false)
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onMounted(() => {
  isEdit.value = Boolean(route.query.storeId)
  if (isEdit.value) {
    getDetail(route.query.storeId)
  } else {
    addOperatingHours()
  }
})
/*获取网店信息*/
const getDetail = async (storeId) => {
  loading.value = true
  try {
    const res = await onlineStoreDetail(storeId)
    if (!res) throw new Error("null")
    Object.assign(ruleForm, res);
    ruleForm.operatingHours.map(i => {
      i.operatingHours = []
      i.operatingHours[0] = moment(moment().format("YYYY-MM-DD ") + i.operatingStart).format()
      i.operatingHours[1] = moment(moment().format("YYYY-MM-DD ") + i.operatingEnd).format()
    })
    console.log("ruleForm.operatingHours", ruleForm.operatingHours)
    // 特殊处理地址反显
    let temp = []
    temp.push(ruleForm.storeShippingAddress.provinceCode)
    temp.push(ruleForm.storeShippingAddress.cityCode)
    temp.push(ruleForm.storeShippingAddress.districtCode)
    ruleForm.showShippingAddressCode = temp.join("/")
    let tempReturn = []
    tempReturn.push(ruleForm.storeReturnAddress.provinceCode)
    tempReturn.push(ruleForm.storeReturnAddress.cityCode)
    tempReturn.push(ruleForm.storeReturnAddress.districtCode)
    ruleForm.showReturnAddress = tempReturn.join("/")
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此网店数据",
        duration: 3000
      })
    }
  }
}

/*表单信息*/
// 表单大小
const formSize = ref('large')
// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  name: null,
  phone: null,
  storeShippingAddress: {
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    addressDetail: null,
  },
  showShippingAddressCode: null,
  storeReturnAddress: {
    provinceCode: null,
    cityCode: null,
    addressDetail: null,
    districtCode: null,
  },
  showReturnAddress: null,
  operatingHours: [],
  description: null
})
// 发货地址校验规则
const checkAddressRule = (rule, value, callback) => {
  if (!ruleForm.storeShippingAddress.provinceCode || !ruleForm.storeShippingAddress.cityCode || !ruleForm.storeShippingAddress.districtCode) {
    return callback(new Error('请选择发货地址省市区'))
  }
  if (!ruleForm.storeShippingAddress.addressDetail) {
    return callback(new Error('请填写详细地址（请勿重复填写省市区）'))
  }
  callback()
}
// 退货地址校验规则
const checkReAddressRule = (rule, value, callback) => {
  if (!ruleForm.storeReturnAddress.provinceCode || !ruleForm.storeReturnAddress.cityCode || !ruleForm.storeReturnAddress.districtCode) {
    return callback(new Error('请选择退货地址省市区'))
  }
  if (!ruleForm.storeReturnAddress.addressDetail) {
    return callback(new Error('请填写详细地址（请勿重复填写省市区）'))
  }
  callback()
}
// 表单校验规则
const rules = reactive({
  name: [
    {required: true, message: '网店名称不能为空', trigger: 'blur'},
  ],
  phone: [
    {required: true, message: '联系电话不能为空', trigger: 'blur'}
  ],
  storeShippingAddress:[
    {required: true, validator: checkAddressRule, trigger: 'blur'}
  ],
  storeReturnAddress: [
    {required: true, validator: checkReAddressRule, trigger: 'blur'}
  ],
  operatingHours: [
    {required: true, message: '请选择营业时间', trigger: 'blur'}
  ]
})
// 表单校验
const submit = async () => {
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createOnlineStore()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      console.log('error submit!', fields)
    }
  })
}
// 创建网店
const createOnlineStore = async () => {
  // 处理营业时间
  ruleForm.operatingHours.map(i => {
    i.operatingStart = moment(i.operatingHours[0]).format("HH:mm")
    i.operatingEnd = moment(i.operatingHours[1]).format("HH:mm")
  })
  try {
    loading.value = true
    if (isEdit.value) {
      await editOrUpdateOnlineStore(ruleForm)
    } else {
      await addOrUpdateOnlineStore(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listOnlineStore')
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单信息
const resetForm = () => {
  router.back()
}
// 处理选择发货地址省市区
const handleSelectAddress = (data) => {
  console.log("data:", data)
  let res = data.value.split("/")
  ruleForm.storeShippingAddress.provinceCode = res[0]
  ruleForm.storeShippingAddress.cityCode = res[1]
  ruleForm.storeShippingAddress.districtCode = res.length > 2 ? res[2] : null
  ruleFormRef.value.validateField("storeShippingAddress")
}
// 处理选择退货地址省市区
const handleSelectReturnAddress = (data) => {
  console.log("data:", data)
  let res = data.value.split("/")
  ruleForm.storeReturnAddress.provinceCode = res[0]
  ruleForm.storeReturnAddress.cityCode = res[1]
  ruleForm.storeReturnAddress.districtCode = res.length > 2 ? res[2] : null
  ruleFormRef.value.validateField("storeReturnAddress")
}

// 开始日期星期数组
const startDataOptions = ref([
  {
    label: "周一",
    value: "MONDAY",
  },
  {
    label: "周二",
    value: "TUESDAY",
  },
  {
    label: "周三",
    value: "WEDNESDAY",
  },
  {
    label: "周四",
    value: "THURSDAY",
  },
  {
    label: "周五",
    value: "FRIDAY",
  },
  {
    label: "周六",
    value: "SATURDAY",
  },
  {
    label: "周日",
    value: "SUNDAY",
  }
])

// 添加营业时间
const addOperatingHours = () => {
  ruleForm.operatingHours.push({
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null,
    operatingHours: []
  })
}
// 删除已填写的营业时间
const removeOperatingHours = (index) => {
  console.log("index", index)
  ruleForm.operatingHours.splice(index, 1)
  ruleFormRef.value.validateField("operatingHours")
}
// 判断营业结束时间选择范围
const handleWeekdayClose = (item, index) => {
  try {
    const findIndex = startDataOptions.value.findIndex(i => i.value === item.weekdayOpen)
    return index < findIndex
  } catch (e) {
    console.log(e)
    return false
  }
}
// 处理更改营业开始时间清空营业关闭时间
const handleClearClose = (index) => {
  ruleForm.operatingHours[index].weekdayClose = null
}
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
     <el-form
         ref="ruleFormRef"
         style="max-width: 600px"
         :model="ruleForm"
         :rules="rules"
         label-width="auto"
         class="demo-ruleForm"
         :size="formSize"
         status-icon
         v-loading="loading"
     >
       <el-form-item label="网店名称：" prop="name">
         <el-input style="max-width: 498px" show-word-limit v-model="ruleForm.name" maxlength="20" placeholder="网店名称最长20个字" />
       </el-form-item>
       <el-form-item label="联系电话：" prop="phone">
         <el-input style="max-width: 498px" show-word-limit v-model="ruleForm.phone" maxlength="11" placeholder="请输入电话号码，座机/手机均可" />
       </el-form-item>
       <el-form-item label="发货地址：" prop="storeShippingAddress">
         <div class="w-100">
           <v-row>
             <v-col cols="12">
               <YTAddress :title="'发货地址'" :addressCode="ruleForm.showShippingAddressCode" :is-return-str="true" @select="handleSelectAddress"></YTAddress>
             </v-col>
           </v-row>
           <v-row>
             <v-col>
               <el-input style="max-width: 498px" v-model="ruleForm.storeShippingAddress.addressDetail" placeholder="请填写详细地址（勿重复填写省市区）" />
             </v-col>
           </v-row>
         </div>
       </el-form-item>
       <el-form-item label="退货地址：" prop="storeReturnAddress">
         <div class="w-100">
           <v-row>
             <v-col cols="12">
               <YTAddress :title="'退货地址'" :addressCode="ruleForm.showReturnAddress" :is-return-str="true" @select="handleSelectReturnAddress"></YTAddress>
             </v-col>
           </v-row>
           <v-row>
             <v-col cols="12">
               <el-input style="max-width: 498px" v-model="ruleForm.storeReturnAddress.addressDetail" placeholder="请填写详细地址（勿重复填写省市区）" />
             </v-col>
           </v-row>
         </div>
       </el-form-item>
       <el-form-item label="营业时间：" prop="operatingHours">
         <div>
           <div class="flex_center mg_b_1" v-for="(item, index) in ruleForm.operatingHours" :key="`operatingHours${index}`">
             <div class="flex">
               <el-select
                   v-model="item.weekdayOpen"
                   placeholder="开始星期"
                   size="large"
                   style="width: 120px"
                   class="mg_r_1"
                   @change="handleClearClose(index)"
               >
                 <el-option
                     v-for="opt in startDataOptions"
                     :key="opt.value"
                     :label="opt.label"
                     :value="opt.value"
                 />
               </el-select>
               <span class="mg_r_1">
                至
              </span>
               <el-select
                   v-model="item.weekdayClose"
                   placeholder="结束星期"
                   size="large"
                   style="width: 120px"
                   class="mg_r_1"
                   :disabled="item.weekdayOpen === null"
               >
                 <el-option
                     v-for="(opt, optIndex) in startDataOptions"
                     :key="opt.value"
                     :label="opt.label"
                     :value="opt.value"
                     :disabled="handleWeekdayClose(item, optIndex)"
                 />
               </el-select>
             </div>
             <div class="flex mg_r_1">
               <el-time-picker class="mg_r_1" format="HH:mm" style="max-width: 150px" v-model="item.operatingHours[0]" placeholder="营业开始时间" />
               <div class="mg_r_1">至</div>
               <el-time-picker format="HH:mm" style="max-width: 150px" v-model="item.operatingHours[1]" placeholder="营业结束时间" />
             </div>
             <el-tooltip
                 class="box-item"
                 effect="dark"
                 content="删除"
                 placement="right">
               <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="removeOperatingHours(index)"></v-icon>
             </el-tooltip>
           </div>
           <div class="flex_left">
             <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="addOperatingHours"></v-icon>
           </div>
         </div>
       </el-form-item>
       <el-form-item label="商家推荐：" prop="description">
         <el-input
             v-model="ruleForm.description"
             style="max-width: 498px"
             :rows="4"
             type="textarea"
             maxlength="200"
             resize="none"
             show-word-limit
             placeholder="你可以简述网店的推荐商品，也可以向客户描述特色服务，例如包邮和7天无理由退货。（最多200个字）"
         />
       </el-form-item>
       <el-form-item label=" ">
         <div>
           <v-row>
             <v-col>
               <v-btn @click="resetForm">取消</v-btn>
             </v-col>
             <v-col>
               <v-btn color="primary" @click="submit" :disabled="!$handleHasBtnPermission('any', 'onlineStore:edit', 'onlineStore:add')">保存</v-btn>
             </v-col>
           </v-row>
         </div>
       </el-form-item>
     </el-form>
    </v-container>
  </div>
</template>

<style scoped>

</style>
